import React from 'react';

import NumberHelper from 'util/number_helper';
import Export from 'components/Explorer/Export';
import SaveSearch from 'components/Explorer/SaveSearch';
import SummaryBlock from 'components/Explorer/ContentPanel/SummaryBlock';
import helpFor from 'util/help.js';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const Summary = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('journals/summary', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const loadingFailed = loading === Loading.ERROR;
  const totalJournals = data?.total_journals ?? 0;

  const content = () => {
    if (loadingFailed) return I18n.t('Explorer.Journals.Summary.error');
    if (totalJournals === 0) return I18n.t('Explorer.Journals.Summary.empty');
    return I18n.htmlSafe('Explorer.Journals.Summary.journals', {
      count: totalJournals,
      formattedCount: NumberHelper.formatNumberWithDelimiter(totalJournals)
    });
  };

  return (
    <SummaryBlock>
      {isLoading ? (
        I18n.t('Explorer.Journals.Summary.loading')
      ) : (
        <>
          <div>{content()}</div>
          <Export endpoint="journals" resultsCount={totalJournals} help={helpFor('journals')} />
          <SaveSearch endpoint="journals" analyticsName="Journals" />
        </>
      )}
    </SummaryBlock>
  );
};

export default Summary;
